// routes
import { paths } from 'src/routes/paths';

export const PATH_AFTER_LOGIN = paths.dashboard.instruments.root;
